import React from "react";
import { otpMobileSign, otpMobileVerify } from "../../../../lib/otpmobilesign";
import { getCountry } from "../../../../lib/myProfile";
import IsdCodeDropdown from "../../../pageBreakup/IsdDropDown/index";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
export default class LoginWithMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginWithMobile: { isd: "+91", mobile: "" },
      loginMobileErr: "",
      otpValue: Array(6).fill(""),
      otpErr: "",
      popupType: "LoginWithMobile",
       onClickLoginLoader: false,

    };
  }

  componentDidMount() {
    getCountry().then((data) => {
      if (data.status) {
        this.setState({ countryData: data?.data || [] });
      }
    });
  }

  // Removed custom ISD dropdown logic

  onChangeLoginMobile = (value, type) => {
    this.setState((prevState) => ({
      loginWithMobile: { ...prevState.loginWithMobile, [type]: value },
      loginMobileErr: "",
    }));
  };

  setMobileError = (error) => {
    this.setState({ loginMobileErr: error });
  };

  onClickValidateMobile = async () => {
    const { mobile } = this.state.loginWithMobile;
    const mobileRegex = /^[1-9][0-9]{6,15}$/;
    if (!mobileRegex.test(mobile)) {
      this.setState({ loginMobileErr: "Please enter a valid mobile number." });
      return;
    }
     this.setState({ onClickLoginLoader: true });
    try {
      const site_id = this.props?.siteData?.data?.site_id;
      const res = await otpMobileSign({ mobile_number: mobile, site_id });
  
      if (res.status) {
        this.setState({ popupType: "VerifyOTP", loginMobileErr: "", onClickLoginLoader: false });
        if (this.props.handlers && typeof this.props.handlers.setPopupType === 'function') {
               this.props.handlers.setPopupType({
            popupCompoenet: 'login',
            popupPage: 'VerifyOTP',
            verifyOtpMobile: { isd: this.state.loginWithMobile.isd, mobile }
          });
        }
      } else {
        this.setState({ loginMobileErr: res.message || "Failed to send OTP." ,onClickLoginLoader: false});
      }
    } catch (err) {
      console.error(err);
      this.setState({ loginMobileErr: "Network error. Please try again." ,onClickLoginLoader: false});
    }
  };

  onChangeOTP = (value, index) => {
    const otpValue = Array.isArray(this.state.otpValue)
      ? this.state.otpValue
      : Array(6).fill("");
    const updatedOtp = [...otpValue];
    updatedOtp[index] = value;
    this.setState({ otpValue: updatedOtp, otpErr: "" });
  };

  onPasteOTP = (index, e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData.getData("text");
    const pastedDigits = clipboardData.match(/\d/g) || [];
    if (pastedDigits.length > 0 && pastedDigits.length <= 6 - index) {
      const otpValue = Array.isArray(this.state.otpValue)
        ? this.state.otpValue
        : Array(6).fill("");
      const updatedOtp = [...otpValue];
      for (let i = 0; i < pastedDigits.length; i++) {
        updatedOtp[index + i] = pastedDigits[i];
      }
      this.setState({ otpValue: updatedOtp, otpErr: "" });
    }
  };

  onKeyDownOTP = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !this.state.otpValue[index]) {
      e.preventDefault();
      const otpValue = Array.isArray(this.state.otpValue)
        ? this.state.otpValue
        : Array(6).fill("");
      const updatedOtp = [...otpValue];
      updatedOtp[index - 1] = "";
      this.setState({ otpValue: updatedOtp, otpErr: "" });
    }
  };



  render() {


    const { styles, handlers , isMobile} = this.props;
    const { loginWithMobile } = this.state;
    let isdDropdownStyles = this.props.isdDropdownStyles;
    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;
      return url;
    };
    const banners = this.props?.siteData?.data?.signin?.banners;
    const PromotionBannerCss = this.props.PromotionBannerCss;
    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: { breakpoint: { max: 1024, min: 464 }, items: 2, slidesToSlide: 2 },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner */}
     <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image"
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
             {
            isMobile?(<div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>):(null)
          }
          
        </div>

        {/* Right side - Login Form */}
        <div className={styles.login_section}>
          <div className={styles.login_form}>
            <div className={styles.form_header}>
              <h3>Login</h3>
              {/* General error message for login attempts */}
              {this.state.loginErrorMsg && (
                <div className={styles.error_message} id="error-message">
                  <div className={styles.error_icon}>
                    <img src="images/te_Invalied.svg" alt="Invalid icon" />
                  </div>
                  <span>{this.state.loginErrorMsg}</span>
                </div>
              )}
            </div>

            <div className={styles.mobile_input_container}>
              <div className={`${styles.form_group}`}>
                <label htmlFor="email">Login with mobile</label>
                <div className={styles.country_mobile_flex}>
                  <div className={styles.country_code}>
                    <IsdCodeDropdown
                      value={loginWithMobile.isd.replace("+", "")}
                      onSelect={(selectedOption) => {
                        this.setState((prevState) => ({
                          loginWithMobile: {
                            ...prevState.loginWithMobile,
                            isd:
                              selectedOption && selectedOption.contry_isd
                                ? `+${selectedOption.contry_isd}`
                                : "+91",
                          },
                        }));
                      }}
                      styles={isdDropdownStyles}
                      theme="theme11"
                    />
                  </div>
                  <input
                    className={`${styles.mobile_input} ${
                      this.state.loginMobileErr ? styles.input_error : ""
                    }`}
                    type="tel"
                    placeholder="Enter your mobile number"
                    value={this.state.loginWithMobile.mobile}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      let errorMessage = "";
                      if (value.length < 7 || value.length > 16) {
                        errorMessage =
                          "Mobile number must be between 7 and 16 digits.";
                      } else if (value.startsWith("0")) {
                        errorMessage = "Mobile number cannot start with zero.";
                      }
                      this.onChangeLoginMobile(value, "mobile");
                      this.setMobileError(errorMessage);
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      let errorMessage = "";
                      if (value.length < 7 || value.length > 16) {
                        errorMessage =
                          "Mobile number must be between 7 and 16 digits.";
                      } else if (value.startsWith("0")) {
                        errorMessage = "Mobile number cannot start with zero.";
                      }
                      this.onChangeLoginMobile(value, "mobile");
                      this.setMobileError(errorMessage);
                    }}
                  />
                </div>

                {this.state.loginMobileErr && (
                  <div className={styles.error_text}>
                    {this.state.loginMobileErr}
                  </div>
                )}
              </div>
            </div>

            <button
              className={`${styles.login_btn} ${this.state.onClickLoginLoader ? "loading" : ''}`}
              onClick={this.onClickValidateMobile}
            >
              Validate
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button>
            <div className={styles.divider}>OR</div>
            <button
              className={styles.mobile_btn}
              onClick={() => {
                if (handlers && typeof handlers.setPopupType === "function") {
                  // handlers.setPopupType("LoginWithEmail");
                     this.props.handlers.setPopupType({
                 popupCompoenet: 'login',
            popupPage: 'LoginWithEmail',
      });
                }
              }}
            >
              Continue with Email
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button>
            <div className={styles.register_link}>
              <span>Don't have an account?</span>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (handlers && typeof handlers.setPopupType === "function") {
                    // handlers.setPopupType("Register",);
                 this.props.handlers.setPopupType({
                 popupCompoenet: 'Register',
            popupPage: 'Register',
      });
                  }
                }}
              >
                Register Now
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
